var Card = function Card(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return /*#__PURE__*/React.createElement("div", {
    className: "card ".concat(className),
    style: style
  }, children);
};
export default Card;